import { useCallback, useSyncExternalStore } from 'react';

/**
 * Whether `query` currently matches. Unlike `useWindowSize`, this re-renders only when the match
 * flips, not on every resize. Returns `serverMatches` on the server and while hydrating, so pass
 * the best guess available there to avoid a flip right after hydration.
 */
export function useMediaQuery(query: string, serverMatches = false): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mediaQueryList = window.matchMedia?.(query);
      mediaQueryList?.addEventListener('change', onChange);
      return () => mediaQueryList?.removeEventListener('change', onChange);
    },
    [query],
  );

  const getSnapshot = useCallback(
    () => window.matchMedia?.(query).matches ?? serverMatches,
    [query, serverMatches],
  );
  const getServerSnapshot = useCallback(() => serverMatches, [serverMatches]);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
